
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import RelationSummaryItem from './RelationSummaryItem'

interface Props {
  item: any
  onSelect: () => void
  readOnly?: boolean
}

const RelationItem = (props: Props) => {

  const { item, onSelect } = props

  const { tasks } = useSelector((state: any) => state.ProgrammationReducer)

  const [ fromTask, setFromTask ] = useState<any>()
  const [ toTask, setToTask ] = useState<any>()

  useEffect(() => {

    const getTasks = () => {

      const fromTask = tasks.find((task: any) => task._id === item.from_task)
      const toTask = tasks.find((task: any) => task._id === item.to_task)

      setFromTask(fromTask)
      setToTask(toTask)
    }

    getTasks()
  }, [ item, tasks ])

  if (!fromTask || !toTask) return null

  return (
    <RelationSummaryItem
      type={item.type}
      originName={fromTask.name}
      destinationName={toTask.name}
      lag={item.lag}
      onSelect={onSelect}
    />
  )
}

export default RelationItem
